import moduleAdviceService from '@/services/v3/ModuleAdviceService.ts'
import { useModuleStatusesStore } from '@/store/pinia/ModuleStatusesStore.ts'
import { storeToRefs } from 'pinia'

export default async () => {
  const moduleStatus = useModuleStatusesStore()
  const { getStatuses } = storeToRefs(moduleStatus)

  // Get current status values at the time this function is called
  const currentStatuses = getStatuses.value

  try {
    const requests: Promise<unknown>[] = []
    if (currentStatuses?.salarySacrificeContributions === 'actioned') {
      requests.push(moduleAdviceService.resetAdviceOnDemand('salary_sacrifice'))
    }

    if (currentStatuses?.lumpSumConcessionalContributions === 'actioned') {
      requests.push(moduleAdviceService.resetAdviceOnDemand('concessional'))
    }

    if (currentStatuses?.debtPlan === 'actioned') {
      requests.push(moduleAdviceService.resetAdviceOnDemand('debt'))
    }

    if (
      currentStatuses?.personalInsurance?.single &&
      typeof currentStatuses.personalInsurance.single === 'object' &&
      Object.values(currentStatuses.personalInsurance.single).includes('actioned')
    ) {
      requests.push(moduleAdviceService.resetAdviceOnDemand('insurance'))
    }

    if (
      requests.length === 0 &&
      Object.values(currentStatuses).some((status) => status === 'ready')
    ) {
      // If no other modules are actioned, still need to refresh userdata
      requests.push(moduleAdviceService.resetAdviceOnDemand('default'))
    }

    // Used to force reset prompts in RetirementPlan.vue
    localStorage.setItem('reset_ai_retirement', 'true')

    await Promise.all(requests)
  } catch (e) {
    console.log('Failed to reset advice: ', e)
  }
}
